import React from 'react';
import { MouseParallax } from 'react-just-parallax';


function MouseFollow({headerImage, overlayImage, content, altHeaderImage, altOverlayImage}) {


  return (
    <>
    <div className='relative z-20 h-lvh overflow-hidden bg-white'>
        <MouseParallax enableOnTouchDevice={false} isAbsolutelyPositioned={true} strength="0.005">
            <img src={headerImage} alt={altHeaderImage} className="absolute top-0 left-0 w-full h-full object-cover z-0" style={{ transform: 'scale(1.2)' }} />
        </MouseParallax>
        <MouseParallax enableOnTouchDevice={false} isAbsolutelyPositioned={true} strength="0.012">
            <img src={overlayImage} alt={altOverlayImage} className="absolute bottom-0 right-0 left-[10rem] xl:left-[25rem] w-full xl:h-full object-cover z-40" style={{ transform: 'scale(1)' }} />
        </MouseParallax>
        {content}
    </div>
    </>
  );
}

export default MouseFollow;
